'use client';

import { useSearchParams } from 'next/navigation';
import React, { useEffect, useMemo, useState } from 'react';
import { isAxiosError } from 'axios';
import { API_PRODUCTS_TODAYS_HOT_DEAL } from '@/constant/apiRout';
import FlashSale from '@/features/flash-sale/flash-sale/components/FlashSale';
import FlashSaleProduct from '@/features/flash-sale/flash-sale-product/components/FlashSaleProduct';
import axios from '@/lib/axios';
import { getTodayDealEndTime } from '@/utils/getTodayDealEndTime';

const TodaysDealContent = () => {
  const searchParams = useSearchParams();
  const page = searchParams.get('page');
  const todayEndTime = useMemo(
    () => getTodayDealEndTime().toISOString(),
    []
  );

  const [products, setProducts] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await axios.get(API_PRODUCTS_TODAYS_HOT_DEAL, {
          headers: { 'Content-Type': 'application/json' },
        });

        const responseData = res.data;
        const normalizedProducts = Array.isArray(responseData)
          ? {
              data: responseData,
              meta: null,
            }
          : responseData;

        setProducts(normalizedProducts);
      } catch (error) {
        console.error("Failed to fetch today's deals products", error);
        if (isAxiosError(error)) {
          // Keep the page usable even if the API request fails.
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [page]);

  return (
    <>
      {products?.data?.length > 0 && (
        <FlashSale dateTimer={todayEndTime} title="Today's Deals" />
      )}
      <FlashSaleProduct flashSales={products} loading={loading} />
    </>
  );
};

export default TodaysDealContent;
